/**
 * Footer section of editor page
 */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { getTemplateInfo } from 'templates/templates'
import * as templateCategory from 'constants/templateCategory'
import InstaFooter from './insta/InstaFooter'

class Footer extends Component {

  render () {
    const { app } = this.props
    const templateInfo = getTemplateInfo(app.templateId)
    if (templateInfo.category === templateCategory.INSTAGRAM_SHOPPABLE) {
      return <InstaFooter app={app} />
    } else {
      return null
    }
  }
}

Footer.propTypes = {
  app: PropTypes.object.isRequired,
}

export default Footer



// WEBPACK FOOTER //
// ./src/components/editor/Footer.js